// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2AqKc","subheader":"ReorderModal_subheader__1EdE5","listWrap":"ReorderModal_listWrap__1iVla"};